<template>
  <div class="checker-search-results">
    <TabView>
      <TabPanel v-if="showUKTrademarkResults" header="UK Trademarks">
        <UKTrademarksResultsTable :search-token="searchToken" />
      </TabPanel>

      <TabPanel v-if="showEUTrademarkResults" header="EU Trademarks">
        <EUTrademarksResultsTable :search-token="searchToken" />
      </TabPanel>

      <TabPanel v-if="showUSTrademarkResults" header="US Trademarks">
        <USTrademarksResultsTable :search-token="searchToken" />
      </TabPanel>

      <!-- <TabPanel header="Social Media" v-if="showSocialResults">
                <SocialResultsTable :search-token="searchToken" />
            </TabPanel> -->

      <TabPanel header="Social Media" v-if="showSocialResults">
        <SocialResultsTable :search-token="searchToken" />
      </TabPanel>

      <!-- <TabPanel
        header="Social Media Users"
        v-if="showSocialUserResults || socialBool"
      >
        <SocialUserResultsTable :search-token="searchToken" />
      </TabPanel> -->

      <TabPanel v-if="showDomainResults" header="Domains" dataKey="name">
        <DataTable
          :paginator="true"
          :rows="50"
          :rowHover="true"
          :scrollable="true"
          scrollHeight="500px"
          showGridlines
          :class="['p-datatable--domains']"
          v-model="domains"
        >
          <template #empty> No Domain results found. </template>

          <template #loading> Loading Domains data. Please wait. </template>

          <Column field="name" header="Domain Name">
            <template #body="{ data }">
              <a :href="'http://' + data.name" target="_blank">{{
                data.name
              }}</a>
            </template>
          </Column>

          <!--                    <Column field="dnssec" header="DNS Sec">-->
          <!--                        <template #body="{ data }">-->
          <!--                            <span v-if="data.dnssec === null">Data Not Found</span>-->
          <!--                            <span v-else>{{ data.dnssec }}</span>-->
          <!--                        </template>-->
          <!--                    </Column>-->

          <!--                    <Column field="status" header="Status">-->
          <!--                        <template #body="{ data }">-->
          <!--                            <span v-if="data.status !== ''">{{ data.status.replace(/([A-Z])/g, ' $1').replace(/^./,-->
          <!--                                function (str) { return str.toUpperCase(); }) }}</span>-->
          <!--                            <span v-else>Data Not Found</span>-->
          <!--                        </template>-->
          <!--                    </Column>-->

          <Column field="registrar" header="Status">
            <template #body="{ data }">
              <span v-if="data.registrar !== ''">Unavailable</span>
              <span v-else>Available</span>
            </template>
          </Column>

          <!--                    <Column field="expires" header="Expires">-->
          <!--                        <template #body="{ data }">-->
          <!--                            <span v-if="data.expired === null">Data Not Found</span>-->
          <!--                            <span v-else>{{ data.expired }}</span>-->
          <!--                        </template>-->
          <!--                    </Column>-->
        </DataTable>

        <template v-if="domains.length > 0">
          <div class="creator-search-results__accordion-copy">
            {{ domains.length }} Domains Found
          </div>
        </template>
      </TabPanel>

      <TabPanel header="Web" v-if="showWebResults">
        <WebResultsTable
          :search-token="searchToken"
          :hitsTotal="results.web_search.total_hits"
        />
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import WebResultsTable from "./WebResultsTable";
import SocialResultsTable from "./SocialResultsTable";
// import SocialUserResultsTable from "./SocialUserResultsTable";
import UKTrademarksResultsTable from "./UKTrademarksResultsTable";
import EUTrademarksResultsTable from "./EUTrademarksResultsTable";
import USTrademarksResultsTable from "./USTrademarksResultsTable";

export default {
  name: "checkerSearchResults",
  props: {
    socialBool: {
      type: Boolean,
      required: false,
    },
    results: {
      type: [],
      required: true,
    },
    searchToken: {
      type: Number,
      required: true,
    },
    showUKTrademarkResults: {
      type: Boolean,
      required: false,
    },
    showEUTrademarkResults: {
      type: Boolean,
      required: false,
    },
    showUSTrademarkResults: {
      type: Boolean,
      required: false,
    },
    showSocialResults: {
      type: Boolean,
      required: false,
    },
    showSocialUserResults: {
      type: Boolean,
      required: false,
    },
    showWebResults: {
      type: Boolean,
      required: false,
    },
    showDomainResults: {
      type: Boolean,
      required: false,
    },
  },
  // mounted() {
  //     console.log('socialbool:', this.socialBool);

  // },
  components: {
    // SocialUserResultsTable,
    EUTrademarksResultsTable,
    UKTrademarksResultsTable,
    USTrademarksResultsTable,
    SocialResultsTable,
    WebResultsTable,
    TabView,
    TabPanel,
    DataTable,
    Column,
  },
  computed: {
    trademarksUK() {
      return this.results.uk_trademark_search ?? [];
    },
    trademarksEU() {
      return this.results.eu_trademark_search ?? [];
    },
    socialMedia() {
      console.log("social media is running");
      return this.results.social_search ? this.results.social_search : [];
    },
    domains() {
      return this.results.domain_search ? this.results.domain_search : [];
    },
    web() {
      return this.results.web_search ? this.results.web_search : [];
    },
  },
  methods: {
    facebookURl(urlstring) {
      let url = new URL(urlstring);

      if (url.pathname.split("/").length >= 4) {
        url = url.protocol + "//" + url.host + "/" + url.pathname.split("/")[1];
      }

      return url;
    },
  },
};
</script>
